import { IFeature } from 'types'
import { FEATURE_NAME } from './Games.model'

export const GamesFeature: IFeature = {
  title: FEATURE_NAME,
}
